import Stack, { StackProps } from "@mui/material/Stack";

/**
 * Augmented version of MUI <Stack> that automatically handles responsive
 * layout for button groups.
 *
 * On larger screens, the buttons will be shown in a row with space between.
 * On mobile, the buttons will be shown in a full-width stack.
 *
 * Note: This component is intended only for use with Buttons as children.
 *
 * This is implemented similarly to the suggested in the MUI documentation:
 * https://mui.com/material-ui/react-stack/#responsive-values
 */
// export const DreamMuiStackForButtons = styled(Stack).attrs({
//   direction: { xs: "column", sm: "row" },
//   alignItems: "stretch",
//   flexWrap: "wrap",
//   gap: 2,
//   mb: 2,
// })``;

export const DreamMuiStackForButtons = (props: StackProps) => (
  <Stack
    direction={{ xs: "column", sm: "row" }}
    alignItems="stretch"
    flexWrap="wrap"
    gap={2}
    mb={2}
    {...props}
  />
);
